import { styled } from '@mui/material';

import Note from '../../../components/Note/index';

export const StyledNote = styled(Note)(({ theme }) => ({
  borderRadius: 0,
  color: theme.palette.warning[900],
  backgroundColor: theme.palette.warning[100],
}));
